import { format } from 'date-fns'
import { FILTER_CHIP_DATE_FORMAT } from 'constants/dateFormats'

export type DateRangeLike = {
  from: Date | null | undefined
  to: Date | null | undefined
}

export function formatDateRange(
  dateRange: DateRangeLike | null | undefined
): string[] {
  if (!dateRange) {
    return []
  }
  const { from, to } = dateRange
  if (!(from instanceof Date) || !(to instanceof Date)) {
    return []
  }
  return [
    `${format(from, FILTER_CHIP_DATE_FORMAT)} to ${format(
      to,
      FILTER_CHIP_DATE_FORMAT
    )}`,
  ]
}
